"use client";
import { useEffect, useRef } from "react";
import { useSearchParams } from "next/navigation";
import { useStore } from "@store/index";

export const useCaptureUtmParams = () => {
    const searchParams = useSearchParams();
    const setUtmParams = useStore((state) => state.setUtmParams);
    const hasCapture = useRef(false);

    useEffect(() => {
        const storedCapture = sessionStorage.getItem("utm_captured");
        if (hasCapture.current || storedCapture) return;

        const utmSource = searchParams.get("utm_source");
        const utmMedium = searchParams.get("utm_medium");
        const utmCampaign = searchParams.get("utm_campaign");
        const utmTerm = searchParams.get("utm_term");
        const utmContent = searchParams.get("utm_content");

        if (utmSource || utmMedium || utmCampaign || utmTerm || utmContent) {
            setUtmParams({
                campaign: utmCampaign || "",
                source: utmSource || "",
                medium: utmMedium || "",
                term: utmTerm || "",
                content: utmContent || "",
            });

            hasCapture.current = true;
            sessionStorage.setItem("utm_captured", "true");
        }
    }, [searchParams, setUtmParams]);
};
